module.exports = __webpack_public_path__ + "static/img/何俊 (2).b873c124.png";